import React from 'react';
import Icon from '@/shared/components/Icon/Icon';
import { IonContent, IonPopover } from '@ionic/react';
import styles from './Tooltip.module.css';

type Props = {
  iconSrc: string;
  id: string;
  showBackdrop: boolean;
  triggerAction: 'hover' | 'click' | 'context-menu';
  content: string;
};

const Tooltip: React.FC<Props> = ({ iconSrc, id, showBackdrop, triggerAction, content }) => {
  return (
    <span>
      <Icon src={iconSrc} id={id} className={styles.icon} />
      <IonPopover showBackdrop={showBackdrop} trigger={id} triggerAction={triggerAction}>
        <IonContent class="ion-padding-start">{content}</IonContent>
      </IonPopover>
    </span>
  );
};

export default Tooltip;
